
const distribuicoes = {
	"labels": [
		{
			"name": "Assets",
			"color": "#78BB42"
		},
		{
			"name": "Bancos múltiplos",
			"color": "#D1DB35"
		},
		{
			"name": "Bancos de investimento",
			"color": "#FAAE1B"
		},
		{
			"name": "Bancos comerciais",
			"color": "#F8DB56"
		},
		{
			"name": "Corretoras",
			"color": "#41B9C3"
		},
		{
			"name": "Distribuidoras",
			"color": "#1D93D1"
		},
		{
			"name": "Demais instituições",
			"color": "#0E3566"
		}
	],
	"years": [
		{
			"year": "2018",
			"total": 260,
			"numbers": [
				{
					"name": "Assets",
					"value": 108,
					"color": "#78BB42"
				},
				{
					"name": "Bancos múltipos",
					"value": 60,
					"color": "#D1DB35"
				},
				{
					"name": "Bancos de investimento",
					"value": 7,
					"color": "#FAAE1B"
				},
				{
					"name": "Bancos comerciais",
					"value": 11,
					"color": "#F8DB56"
				},
				{
					"name": "Corretoras",
					"value": 34,
					"color": "#41B9C3"
				},
				{
					"name": "Distribuidoras",
					"value": 30,
					"color": "#1D93D1"
				},
				{
					"name": "Demais instituições",
					"value": 10,
					"color": "#0E3566"
				}
			]
		},
		{
			"year": "2017",
			"total": 267,
			"numbers": [
				{
					"name": "Assets",
					"value": 111,
					"color": "#78BB42"
				},
				{
					"name": "Bancos múltipos",
					"value": 59,
					"color": "#D1DB35"
				},
				{
					"name": "Bancos de investimento",
					"value": 7,
					"color": "#FAAE1B"
				},
				{
					"name": "Bancos comerciais",
					"value": 13,
					"color": "#F8DB56"
				},
				{
					"name": "Corretoras",
					"value": 34,
					"color": "#41B9C3"
				},
				{
					"name": "Distribuidoras",
					"value": 31,
					"color": "#1D93D1"
				},
				{
					"name": "Demais instituições",
					"value": 12,
					"color": "#0E3566"
				}
			]
		},
		{
			"year": "2016",
			"total": 271,
			"numbers": [
				{
					"name": "Assets",
					"value": 110,
					"color": "#78BB42"
				},
				{
					"name": "Bancos múltipos",
					"value": 63,
					"color": "#D1DB35"
				},
				{
					"name": "Bancos de investimento",
					"value": 7,
					"color": "#FAAE1B"
				},
				{
					"name": "Bancos comerciais",
					"value": 12,
					"color": "#F8DB56"
				},
				{
					"name": "Corretoras",
					"value": 35,
					"color": "#41B9C3"
				},
				{
					"name": "Distribuidoras",
					"value": 33,
					"color": "#1D93D1"
				},
				{
					"name": "Demais instituições",
					"value": 11,
					"color": "#0E3566"
				}
			]
		}
	]
};

export { distribuicoes };